import type { OsVersionResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { ApplicationVersionAutocompleteFieldValue } from '../../../../components/application-version-fields/applicationVersionFields.model';
import type { SystemPackageVersionAutocompleteFieldValue } from '../../../../components/system-package-version-fields/systemPackageVersionFields.model';

export function mapOsVersionsByIdForSystemPackage({
  data,
}: OsVersionResourceListResponseV2Api): SystemPackageVersionAutocompleteFieldValue[] {
  return data.map(({ id: value = '', versionNumber: label = '' }) => ({ value, label }));
}

export function mapOsVersionsByIdForApplication({
  data,
}: OsVersionResourceListResponseV2Api): ApplicationVersionAutocompleteFieldValue[] {
  return data.map(({ id: value = '', versionNumber: label = '' }) => ({ value, label }));
}
